import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':materialId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:materialId`;

export const URL = (materialId: number): RouteDefinition => `${baseRoute}/${materialId}`;
